import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';


const SearchBar = ({ onSearch, onFilterToggle, placeholder = "Search news, articles, and insights..." }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [isAdvancedOpen, setIsAdvancedOpen] = useState(false);

  const handleSearch = (e) => {
    e?.preventDefault();
    onSearch(searchQuery);
  };

  const handleInputChange = (e) => {
    setSearchQuery(e?.target?.value);
    // Trigger search on input change for real-time results
    onSearch(e?.target?.value);
  };

  const toggleAdvanced = () => {
    setIsAdvancedOpen(!isAdvancedOpen);
    onFilterToggle?.(!isAdvancedOpen);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <form onSubmit={handleSearch} className="space-y-4">
        <div className="relative">
          <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
            <Icon name="Search" size={20} className="text-muted-foreground" />
          </div>
          <input
            type="text"
            value={searchQuery}
            onChange={handleInputChange}
            placeholder={placeholder}
            className="w-full pl-10 pr-12 py-3 bg-input border border-border rounded-lg text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-200"
          />
          <div className="absolute inset-y-0 right-3 flex items-center space-x-2">
            <button
              type="button"
              onClick={toggleAdvanced}
              className={`p-1 rounded-md transition-colors duration-200 ${
                isAdvancedOpen
                  ? 'text-primary bg-primary/10' :'text-muted-foreground hover:text-card-foreground hover:bg-muted/50'
              }`}
            >
              <Icon name="SlidersHorizontal" size={16} />
            </button>
          </div>
        </div>

        {isAdvancedOpen && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-4 border-t border-border animate-slide-up">
            <div>
              <label className="block text-xs font-medium text-muted-foreground mb-2">
                Date Range
              </label>
              <select className="w-full px-3 py-2 bg-input border border-border rounded-lg text-foreground text-sm focus:outline-none focus:ring-2 focus:ring-primary">
                <option value="all">All Time</option>
                <option value="today">Today</option>
                <option value="week">This Week</option>
                <option value="month">This Month</option>
                <option value="year">This Year</option>
              </select>
            </div>

            <div>
              <label className="block text-xs font-medium text-muted-foreground mb-2">
                Content Type
              </label>
              <select className="w-full px-3 py-2 bg-input border border-border rounded-lg text-foreground text-sm focus:outline-none focus:ring-2 focus:ring-primary">
                <option value="all">All Types</option>
                <option value="article">Articles</option>
                <option value="guide">Guides</option>
                <option value="news">News</option>
                <option value="analysis">Analysis</option>
              </select>
            </div>

            <div>
              <label className="block text-xs font-medium text-muted-foreground mb-2">
                Sort By
              </label>
              <select className="w-full px-3 py-2 bg-input border border-border rounded-lg text-foreground text-sm focus:outline-none focus:ring-2 focus:ring-primary">
                <option value="relevance">Relevance</option>
                <option value="date">Date</option>
                <option value="popularity">Popularity</option>
                <option value="trending">Trending</option>
              </select>
            </div>
          </div>
        )}
      </form>
    </div>
  );
};

export default SearchBar;